import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/gses.webp';
import screenshot_target from '../../../images/letterfunnel/kellyruigrok.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Kelly Ruigrok"
      firstname="Kelly"
      companyname="GSES"
      competition="EcoVadis en IntegrityNext"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/kellyruigrok.js